import { Normalize } from 'react-i18next';
import en from '../i18n/en';

export class RevxErrorCode {
  constructor(
    public code: number,
    public name: string,
    public i18nKey: Normalize<typeof en>
  ) {}
}

export interface RevxErrorMessage {
  errorCode?: RevxErrorCode;
  originalMessage?: string;
  message: string;
}

// @formatter:off
export const RevxErrorCodes: { [key: string]: RevxErrorCode } = {
  '503': new RevxErrorCode(
    503,
    'SERVICE_UNAVAILABLE',
    'errors.serviceUnavailable'
  ),
  '401': new RevxErrorCode(401, 'FORBIDDEN', 'errors.forbidden'),
  '-1': new RevxErrorCode(-1, 'FAILURE', 'errors.default.failure'),
  '0': new RevxErrorCode(0, 'SUCCESS', 'errors.default.success'),
  '11001': new RevxErrorCode(
    11001,
    'ACCOUNT_TOKEN_INVALID',
    'errors.login.accountTokenInvalid'
  ),
  '11002': new RevxErrorCode(
    11002,
    'ACCOUNT_EMAIL_EXISTS',
    'errors.login.accountEmailExists'
  ),
  '12001': new RevxErrorCode(
    12001,
    'LOGIN_FAILED_UNKNOWN',
    'errors.login.loginFailedUnknown'
  ),
  '12002': new RevxErrorCode(
    12002,
    'LOGIN_ACCOUNT_NOT_FOUND',
    'errors.login.loginAccountNotFound'
  ),
  '12003': new RevxErrorCode(
    12003,
    'LOGIN_BAD_CREDENTIALS',
    'errors.login.loginBadCredentials'
  ),
  '12004': new RevxErrorCode(
    12004,
    'LOGIN_ACCOUNT_EXPIRED',
    'errors.login.loginAccountExpired'
  ),
  '12005': new RevxErrorCode(
    12005,
    'LOGIN_ACCOUNT_LOCKED',
    'errors.login.loginFailedUnknown'
  ),
  '12006': new RevxErrorCode(
    12006,
    'LOGIN_ACCOUNT_DISABLED',
    'errors.login.loginFailedUnknown'
  ),
  '12007': new RevxErrorCode(
    12007,
    'LOGIN_CREDENTIALS_EXPIRED',
    'errors.login.loginCredentialsExpired'
  ),
  '13001': new RevxErrorCode(
    13001,
    'USER_EMAIL_EXISTS',
    'errors.user.emailAlreadyInUse'
  ),
  '13002': new RevxErrorCode(
    13002,
    'USER_EMAIL_NOT_FOUND',
    'errors.login.userEmailNotFound'
  ),
  '13003': new RevxErrorCode(
    13003,
    'USER_EMAIL_INVALID',
    'errors.default.failure'
  ),
  '13004': new RevxErrorCode(13004, 'ROLE_NOT_FOUND', 'errors.default.failure'),
  '13005': new RevxErrorCode(
    13005,
    'USER_RENEW_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '21001': new RevxErrorCode(
    21001,
    'COMPANY_NOT_FOUND',
    'errors.default.failure'
  ),
  '21002': new RevxErrorCode(
    21002,
    'COMPANY_DEL_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '21003': new RevxErrorCode(
    21003,
    'ADDRESS_DEL_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '21004': new RevxErrorCode(
    21004,
    'CONTACT_DEL_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '21005': new RevxErrorCode(
    21005,
    'CONTACT_NOT_FOUND',
    'errors.default.failure'
  ),
  '21007': new RevxErrorCode(
    21007,
    'ORG_EMAIL_EXISTS',
    'errors.default.failure'
  ),
  '21008': new RevxErrorCode(
    21008,
    'ORG_EMAIL_INVALID',
    'errors.default.failure'
  ),
  '21010': new RevxErrorCode(
    21010,
    'COUNTRY_CODE_INVALID',
    'errors.default.failure'
  ),
  '21011': new RevxErrorCode(21011, 'ORG_NOT_FOUND', 'errors.default.failure'),
  '21012': new RevxErrorCode(21012, 'USER_NOT_FOUND', 'errors.default.failure'),
  '21013': new RevxErrorCode(
    21013,
    'ORG_DEL_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '21015': new RevxErrorCode(
    21015,
    'ADDRESS_INVALID',
    'errors.default.failure'
  ),
  '21016': new RevxErrorCode(
    21016,
    'STATE_CODE_INVALID',
    'errors.shipping.stateCodeInvalid'
  ),
  '21020': new RevxErrorCode(
    21020,
    'CAN_ONLY_CHANGE_ROOT_ORG_TYPE',
    'errors.org.canOnlyChangeRootOrgType'
  ),
  '21021': new RevxErrorCode(
    21021,
    'CANNOT_CHANGE_DEFAULT_ORG_TYPE',
    'errors.org.changeDefaultOrgTypeNotAllowed'
  ),

  '22001': new RevxErrorCode(
    22001,
    'CANNOT_REMOVE_FROM_NETWORK',
    'errors.network.cannotRemoveFromNetwork'
  ),

  '23000': new RevxErrorCode(
    23000,
    'SHIPPING_ACCOUNT_CONFIG_ERROR',
    'errors.rfq.shippingAccountConfigError'
  ),
  '24001': new RevxErrorCode(
    24001,
    'MARKUP_TYPE_EXISTS',
    'errors.default.failure'
  ),
  '24002': new RevxErrorCode(
    24002,
    'MARKUP_PERIOD_OVERLAPPED',
    'errors.default.failure'
  ),
  '24003': new RevxErrorCode(
    24003,
    'MARKUP_TYPE_UNSUPPORTED',
    'errors.default.failure'
  ),
  '24006': new RevxErrorCode(
    24006,
    'MARKUP_TYPE_UNSUPPORTED',
    'errors.platform.markupDuplicate'
  ),
  '25001': new RevxErrorCode(
    25001,
    'TURNTIME_DEL_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '25002': new RevxErrorCode(
    25002,
    'TURNTIME_NOT_FOUND',
    'errors.default.failure'
  ),
  '25003': new RevxErrorCode(
    25003,
    'TURNTIME_INACTIVATE_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '25004': new RevxErrorCode(25004, 'DOW_OVERLAPPED', 'errors.default.failure'),
  '31001': new RevxErrorCode(31001, 'SKU_NOT_FOUND', 'errors.default.failure'),
  '31002': new RevxErrorCode(
    31002,
    'SKU_CREATE_FAILED',
    'errors.default.failure'
  ),
  '31003': new RevxErrorCode(
    31003,
    'SKU_INHERIT_FAILED_MISSING_EQUIPMENT',
    'errors.default.failure'
  ),
  '31004': new RevxErrorCode(
    31004,
    'SKU_INHERIT_FAILED_MISSING_SVC',
    'errors.default.failure'
  ),
  '31005': new RevxErrorCode(
    31005,
    'SKU_DEL_NOT_ALLOWED_USED',
    'errors.default.failure'
  ),
  '31006': new RevxErrorCode(
    31006,
    'SKU_DEL_NOT_ALLOWED_BASE',
    'errors.default.failure'
  ),
  '31007': new RevxErrorCode(
    31007,
    'SKU_SIZE_UPDATE_FAILED_USED',
    'errors.default.failure'
  ),
  '31010': new RevxErrorCode(
    31010,
    'SKU_ADD_MULTI_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '31011': new RevxErrorCode(
    31011,
    'SKU_ADD_MULTI_EXISTS',
    'errors.default.failure'
  ),
  '31012': new RevxErrorCode(
    31012,
    'SKU_ORIENTATION_NOT_COMPATIBLE',
    'errors.default.failure'
  ),
  '31013': new RevxErrorCode(
    31013,
    'SKU_REMOVE_MULTI_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '31014': new RevxErrorCode(
    31014,
    'SKU_ACTIVATE_NOT_ALLOWED_BASE_INACTIVE',
    'errors.default.failure'
  ),
  '31015': new RevxErrorCode(
    31015,
    'SKU_INACTIVATE_NOT_ALLOWED_USED',
    'errors.default.failure'
  ),
  '31016': new RevxErrorCode(
    31016,
    'SKU_ACTIVATE_NOT_ALLOWED_PART_INACTIVE',
    'errors.default.failure'
  ),
  '31017': new RevxErrorCode(
    31017,
    'SKU_UPDATE_NOT_ALLOWED_DRAFT',
    'errors.default.failure'
  ),
  '31018': new RevxErrorCode(
    31018,
    'SKU_PUBLISH_FAILED_PART_TO_STANDALONE',
    'errors.default.failure'
  ),
  '31019': new RevxErrorCode(
    31019,
    'SKU_PUBLISH_FAILED_MISSING_IMAGE',
    'errors.default.failure'
  ),
  '31020': new RevxErrorCode(
    31020,
    'SKU_PUBLISH_FAILED_MISSING_DEFAULT_QTY',
    'errors.default.failure'
  ),
  '31021': new RevxErrorCode(
    31021,
    'SKU_PUBLISH_FAILED_MISSING_DEFAULT_PAGE_COUNT',
    'errors.default.failure'
  ),
  '31022': new RevxErrorCode(
    31022,
    'SKU_PUBLISH_FAILED_MISSING_SIDES',
    'errors.default.failure'
  ),
  '31023': new RevxErrorCode(
    31023,
    'SKU_PUBLISH_FAILED_MISSING_SIZE',
    'errors.default.failure'
  ),
  '31024': new RevxErrorCode(
    31024,
    'SKU_PUBLISH_FAILED_MISSING_DEFAULT_BLEED',
    'errors.default.failure'
  ),
  '31025': new RevxErrorCode(
    31025,
    'SKU_PUBLISH_FAILED_MISSING_RULE_CODE',
    'errors.default.failure'
  ),
  '31026': new RevxErrorCode(
    31026,
    'SKU_PUBLISH_FAILED_MISSING_ORIENTATION',
    'errors.default.failure'
  ),
  '31027': new RevxErrorCode(
    31027,
    'SKU_PUBLISH_FAILED_INVALID_DRAFT',
    'errors.default.failure'
  ),
  '31042': new RevxErrorCode(
    31042,
    'SKU_PUBLISH_FAILED_INVALID_DRAFT',
    'errors.unitPrice.gap'
  ),
  '32001': new RevxErrorCode(
    32001,
    'EQUIMENT_BASE_DUPLICATED',
    'errors.default.failure'
  ),
  '32002': new RevxErrorCode(
    32002,
    'EQUIMENT_NOT_FOUND',
    'errors.default.failure'
  ),
  '32003': new RevxErrorCode(
    32003,
    'EQUIMENT_COMPONENT_CODE_UNSUPPORTED',
    'errors.default.failure'
  ),
  '33001': new RevxErrorCode(
    33001,
    'MATERIAL_BASE_DUPLICATED',
    'errors.default.failure'
  ),
  '34001': new RevxErrorCode(
    34001,
    'SVC_SPEC_COUNT_UNEXPECTED',
    'errors.default.failure'
  ),
  '34002': new RevxErrorCode(
    34002,
    'SVC_BASE_DUPLICATED',
    'errors.default.failure'
  ),
  '34003': new RevxErrorCode(
    34003,
    'SVC_TYPE_NOT_FOUND',
    'errors.default.failure'
  ),
  '35001': new RevxErrorCode(
    35001,
    'PARCEL_BASE_DUPLICATED',
    'errors.default.failure'
  ),
  '36001': new RevxErrorCode(
    36001,
    'GALLERY_LABEL_PARENT_INVALID',
    'errors.default.failure'
  ),
  '36002': new RevxErrorCode(
    36002,
    'GALLERY_LABEL_DEL_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '36003': new RevxErrorCode(
    36003,
    'DICT_KEY_EXISTS',
    'errors.default.failure'
  ),
  '36004': new RevxErrorCode(
    36004,
    'DICT_TYPE_NOT_FOUND',
    'errors.default.failure'
  ),
  '41001': new RevxErrorCode(
    41001,
    'WRAPPER_SVC_NOT_FOUND',
    'errors.jobconfig.wrapperSvcNotFound'
  ),
  '41002': new RevxErrorCode(41002, 'N_UP_ZERO', 'errors.jobconfig.nUpZero'),
  '41003': new RevxErrorCode(
    41003,
    'MATERIAL_UOM_COEFFICIENT_UNSUPPORTED',
    'errors.default.failure'
  ),
  '41004': new RevxErrorCode(
    41004,
    'UOM_COEFFICIENT_UNSUPPORTED',
    'errors.default.failure'
  ),
  '41005': new RevxErrorCode(
    41005,
    'NO_ELIGIBLE_SUPPLIER',
    'errors.jobconfig.noEligibleSupplier'
  ),
  '41006': new RevxErrorCode(
    41006,
    'THICKNESS_EXCEED_MAX_CALIPER',
    'errors.jobconfig.thicknessExceedMaxCaliper'
  ),
  '41007': new RevxErrorCode(
    41007,
    'NO_ELIGIBLE_COMB',
    'errors.default.failure'
  ),
  '41008': new RevxErrorCode(
    41008,
    'ORG_CANNOT_PRODUCE',
    'errors.default.failure'
  ),
  '41028': new RevxErrorCode(
    41028,
    'BACK_PLATE_COUNT_EXCEED',
    'errors.jobconfig.improveTotalPlatesBackErrorMessage'
  ),
  '41029': new RevxErrorCode(
    41029,
    'FRONT_PLATE_COUNT_EXCEED',
    'errors.jobconfig.improveTotalPlatesFrontErrorMessage'
  ),
  '42001': new RevxErrorCode(
    42001,
    'JOB_SPEC_NOT_FOUND',
    'errors.default.failure'
  ),
  '42002': new RevxErrorCode(
    42002,
    'SELECTED_JOB_SPEC_NOT_FOUND',
    'errors.default.failure'
  ),
  '42003': new RevxErrorCode(
    42003,
    'SVC_OPTION_TYPE_UNSUPPORTED',
    'errors.default.failure'
  ),
  '42004': new RevxErrorCode(
    42004,
    'PDF_TEMPLATE_UNSUPPORTED',
    'errors.default.failure'
  ),
  '42005': new RevxErrorCode(
    42005,
    'WRAPPER_JOB_SPEC_NOT_FOUND',
    'errors.default.failure'
  ),
  '42006': new RevxErrorCode(
    42006,
    'SHIPPING_ITEM_FULFILLMENT_NOT_FOUND',
    'errors.default.failure'
  ),
  '42007': new RevxErrorCode(
    42007,
    'JOB_FULFILLMENT_NOT_FOUND',
    'errors.default.failure'
  ),
  '42008': new RevxErrorCode(
    42008,
    'SVC_FULFILLMENT_NOT_FOUND',
    'errors.default.failure'
  ),
  '42009': new RevxErrorCode(
    42009,
    'JOB_CONFIG_CACHE_NOT_FOUND',
    'errors.jobconfig.jobConfigCacheNotFound'
  ),
  '42010': new RevxErrorCode(
    42010,
    'ARTWORK_FILE_DUPLICATED',
    'errors.jobconfig.artworkFileDuplicated'
  ),
  '42012': new RevxErrorCode(
    42012,
    'USER_DEFAULT_CONTACT_NOT_FOUND',
    'errors.jobconfig.userDefaultContactNotFound'
  ),
  '42014': new RevxErrorCode(
    42014,
    'QTY_ITEM_DEL_NOT_ALLOWED',
    'errors.default.failure'
  ),
  '42015': new RevxErrorCode(
    42015,
    'ARTWORK_FILE_NOT_FOUND',
    'errors.default.failure'
  ),
  '42016': new RevxErrorCode(
    42016,
    'SKU_NOT_FOR_SALE',
    'errors.default.failure'
  ),
  '42017': new RevxErrorCode(
    42017,
    'AVL_PARCEL_NOT_FOUND',
    'errors.jobconfig.avlParcelNotFound'
  ),
  '42019': new RevxErrorCode(
    42019,
    'PART_JOB_SPEC_NOT_FOUND',
    'errors.default.failure'
  ),
  '42020': new RevxErrorCode(
    42020,
    'JOB_CONFIG_UNSATISFIED',
    'errors.jobconfig.jobConfigUnsatisfied'
  ),
  '42021': new RevxErrorCode(
    42021,
    'SVC_EXCLUSIVE_TYPE_UNSUPPORTED',
    'errors.default.failure'
  ),
  '42022': new RevxErrorCode(42022, 'SVC_NOT_FOUND', 'errors.default.failure'),
  '42023': new RevxErrorCode(
    42023,
    'QTY_DEPENDENCY_UNSUPPORTED',
    'errors.default.failure'
  ),
  '42024': new RevxErrorCode(
    42024,
    'QTY_PER_BUNDLE_INVALID',
    'errors.jobconfig.qtyPerBundleInvalid'
  ),
  '42026': new RevxErrorCode(
    42026,
    'SERVICE_EMPTY',
    'errors.jobconfig.noAvailableServicesErrorMessage'
  ),
  '42028': new RevxErrorCode(
    42028,
    'CANNOT_ADD_TO_CART_ORDER_NOW',
    'errors.jobconfig.cannotAddToCartOrderNow'
  ),
  '42030': new RevxErrorCode(
    42028,
    'QUANTITY_LOCKED',
    'errors.jobconfig.qtyLocked'
  ),
  '42031': new RevxErrorCode(
    42028,
    'JOB_PROOFS_NOT_APPROVED',
    'errors.jobconfig.proofsNotApproved'
  ),
  '42033': new RevxErrorCode(
    42033,
    'INDUSTRY_AVERAGE_ADD_TO_CART_DISABLED',
    'errors.jobconfig.industryAverageAddToCartDisabled'
  ),
  '43001': new RevxErrorCode(
    43001,
    'PROOF_TYPE_INVALID',
    'errors.default.failure'
  ),
  '43002': new RevxErrorCode(
    43002,
    'JOB_TOTAL_PRICE_INVALID',
    'errors.default.failure'
  ),
  '43003': new RevxErrorCode(
    43003,
    'DEFAULT_TURNTIME_NOT_FOUND',
    'errors.default.failure'
  ),
  '43004': new RevxErrorCode(
    43004,
    'AVL_TURNTIME_NOT_FOUND',
    'errors.default.failure'
  ),
  '44001': new RevxErrorCode(
    44001,
    'ORDER_NOT_FOUND',
    'errors.default.failure'
  ),
  '44002': new RevxErrorCode(
    44002,
    'ORDER_FAILED_JOB_INVALID',
    'errors.default.failure'
  ),
  '44003': new RevxErrorCode(
    44003,
    'PAYMENT_PROCESSING',
    'errors.order.paymentProcessing'
  ),
  '44005': new RevxErrorCode(
    44005,
    'REORDER_FAILED_SVC_NOT_MATCH',
    'errors.order.reorderFailedSvcNotMatch'
  ),
  '44006': new RevxErrorCode(
    44006,
    'ORDER_FAILED_MISSING_BILLING',
    'errors.default.failure'
  ),
  '44008': new RevxErrorCode(
    44008,
    'ORDER_FAILED_JOB_ORDERED',
    'errors.order.orderFailedJobOrdered'
  ),
  '44009': new RevxErrorCode(
    44009,
    'ORDER_FAILED_JOB_EMPTY',
    'errors.default.failure'
  ),
  '44011': new RevxErrorCode(
    44011,
    'ORDER_HAS_BEEN_PAID',
    'errors.order.orderHasBeenPaid'
  ),
  '46001': new RevxErrorCode(
    46001,
    'CACHED_JOB_RFQ_NOT_FOUND',
    'errors.rfq.cachedJobRFQNotFound'
  ),
  '46002': new RevxErrorCode(
    46002,
    'JOB_RFQ_NOT_FOUND',
    'errors.rfq.jobRFQNotFound'
  ),
  '46003': new RevxErrorCode(
    46003,
    'JOB_RFQ_ORG_ITEM_NOT_FOUND',
    'errors.rfq.jobRFQOrgItemNotFound'
  ),
  '46004': new RevxErrorCode(
    46004,
    'ORG_ID_CANNOT_FIND_ORG_ITEM',
    'errors.rfq.orgIdCannotFindOrgItem'
  ),
  '46005': new RevxErrorCode(
    46005,
    'SERIAL_NUM_CANNOT_FIND_QTY_ITEM',
    'errors.rfq.serialNumCannotFindQtyItem'
  ),
  '46006': new RevxErrorCode(
    46006,
    'NO_AUTH_HANDLE_RFQ',
    'errors.rfq.noAuthHandleRfq'
  ),
  '46007': new RevxErrorCode(
    46007,
    'CACHED_JOB_RFQ_QUOTE_NOT_FOUND',
    'errors.rfq.cachedJobRfqQuoteNotFound'
  ),
  '46008': new RevxErrorCode(
    46008,
    'ORG_ID_CANNOT_FIND_CACHED_ORG_ITEM',
    'errors.rfq.orgIdCannotFindCachedOrgItem'
  ),
  '46009': new RevxErrorCode(
    46009,
    'SERIAL_NUM_CANNOT_FIND_CACHED_QTY_ITEM',
    'errors.rfq.serialNumCannotFindCachedQtyItem'
  ),
  '46010': new RevxErrorCode(
    46010,
    'JOB_RFQ_ALREADY_CLOSE',
    'errors.rfq.jobRfqAlreandClose'
  ),
  '46011': new RevxErrorCode(
    46011,
    'JOB_RFQ_EXPIRED',
    'errors.rfq.jobRfqExpired'
  ),
  '46014': new RevxErrorCode(
    46014,
    'JOB_RFQ_INVALID_READY_DATE',
    'errors.rfq.invalidReadyDate'
  ),
  '46016': new RevxErrorCode(
    46014,
    'JOB_RFQ_DUPLICATE',
    'errors.rfq.jobRfqDuplicate'
  ),
  '51001': new RevxErrorCode(
    51001,
    'RFM_JOB_ALREADY_CLAIMED',
    'errors.workflow.rfmJobAlreadyClaimed'
  ),
  '51002': new RevxErrorCode(
    51002,
    'PRESS_NOT_FOUND_WITH_FULFILLMENT',
    'errors.default.failure'
  ),
  '51003': new RevxErrorCode(
    51003,
    'PRESS_TYPE_NOT_FOUND_WITH_FULFILLMENT',
    'errors.default.failure'
  ),
  '51006': new RevxErrorCode(
    51006,
    'OFFER_EXPIRATION_DATE_INVALID',
    'errors.default.failure'
  ),
  '51007': new RevxErrorCode(
    51007,
    'OFFER_ROUND_DUPLICATED',
    'errors.default.failure'
  ),
  '51008': new RevxErrorCode(
    51008,
    'OFFER_ROUND_NOT_CONTINUOUS',
    'errors.default.failure'
  ),
  '51009': new RevxErrorCode(
    51009,
    'OFFER_ALREADY_ACCEPTED',
    'errors.workflow.offerAlreadyAccepted'
  ),
  '51010': new RevxErrorCode(
    51010,
    'SHIPPING_CARRIER_NOT_FOUND',
    'errors.default.failure'
  ),
  '51011': new RevxErrorCode(
    51011,
    'INVITATION_NOT_FOUND',
    'errors.default.failure'
  ),
  '51012': new RevxErrorCode(
    51012,
    'INVITATION_EXPIRED',
    'errors.workflow.invitationExpired'
  ),
  '51013': new RevxErrorCode(
    51013,
    'INVITATION_ALREADY_DECIDED',
    'errors.workflow.invitationAlreadyDecided'
  ),
  '52002': new RevxErrorCode(
    52002,
    'JOB_STATUS_UNEXPECTED',
    'errors.workflow.jobStatusUnexpected'
  ),
  '52003': new RevxErrorCode(
    52003,
    'ROLE_UNSUPPORTED',
    'errors.workflow.roleUnsupported'
  ),
  '52004': new RevxErrorCode(
    52004,
    'SOURCER_CONTACTS_NOT_FOUND',
    'errors.default.failure'
  ),
  '52005': new RevxErrorCode(
    52005,
    'STATUS_FILTER_UNSUPPORTED',
    'errors.default.failure'
  ),
  '52006': new RevxErrorCode(
    52006,
    'PO_STATUS_UNEXPECTED',
    'errors.default.failure'
  ),
  '52007': new RevxErrorCode(52007, 'PO_EXPIRED', 'errors.workflow.poExpired'),
  '52008': new RevxErrorCode(52008, 'PO_NOT_FOUND', 'errors.default.failure'),
  '53002': new RevxErrorCode(
    53002,
    'MAX_FILES_EXCEEDED',
    'errors.default.failure'
  ),
  '53003': new RevxErrorCode(53003, 'JOB_NOT_FOUND', 'errors.default.failure'),
  '53004': new RevxErrorCode(
    53004,
    'ARTWORK_FILE_DEL_NOT_ALLOWED',
    'errors.workflow.artworkFileDelNotAllowed'
  ),
  '53006': new RevxErrorCode(
    53006,
    'JOB_ACCESS_DENIED',
    'errors.workflow.jobAccessDenied'
  ),
  '53007': new RevxErrorCode(
    53007,
    'JOB_VERSION_NOT_FOUND',
    'errors.default.failure'
  ),
  '55001': new RevxErrorCode(
    55001,
    'JOB_PARTICIPANT_EMPTY',
    'errors.default.failure'
  ),
  '55002': new RevxErrorCode(
    55002,
    'JOB_PARTICIPANT_UNSUPPORTED',
    'errors.default.failure'
  ),
  '56004': new RevxErrorCode(
    56004,
    'CANNOT_CREATE_ADJUSTMENT_DUPLICATED',
    'errors.workflow.cannotCreateAdjustmentDuplicated'
  ),
  '56005': new RevxErrorCode(
    56005,
    'CANNOT_CREATE_ADJUSTMENT_DUPLICATED',
    'errors.workflow.jobNotFind'
  ),
  '56015': new RevxErrorCode(
    56015,
    'CANNOT_CREATE_ADJUSTMENT_DUPLICATED',
    'errors.workflow.cannotCreateAdjustmentCost'
  ),
  '57001': new RevxErrorCode(
    57001,
    'PROOF_NOT_FOUND',
    'errors.default.failure'
  ),
  '57002': new RevxErrorCode(
    57002,
    'PROOF_TYPE_MISMATCH',
    'errors.default.failure'
  ),
  '57003': new RevxErrorCode(
    57003,
    'SHIPPING_INFO_REQUIRED',
    'errors.default.failure'
  ),
  '57004': new RevxErrorCode(
    57004,
    'PROOF_STATUS_UNEXPECTED',
    'errors.workflow.proofStatusUnexpected'
  ),
  '57005': new RevxErrorCode(
    57005,
    'PROOF_FILES_NOT_FOUND',
    'errors.default.failure'
  ),
  '57006': new RevxErrorCode(
    57006,
    'PROOF_SHIPPING_CONTACT_NOT_FOUND',
    'errors.default.failure'
  ),
  '57007': new RevxErrorCode(
    57007,
    'PROOF_SHIPPING_CONTACT_ADDR_NOT_FOUND',
    'errors.default.failure'
  ),
  '59102': new RevxErrorCode(
    59102,
    'JOB_CONFIG_DYNAMIC_FIELD_TOO_LONG',
    'errors.jobconfig.fieldTooLongErrorMessage'
  ),
  '58006': new RevxErrorCode(
    58006,
    'JOB_CANCELLATION_SUBMIT_MISSING_INVOICE_URL',
    'errors.workflow.uploadCustomerInvoiceFile'
  ),
  '58007': new RevxErrorCode(
    58007,
    'JOB_CANCELLATION_SUBMIT_MISSING_SUPPLIER_CHECK',
    'errors.workflow.confirmSupplierTerms'
  ),
  '58008': new RevxErrorCode(
    58008,
    'JOB_CANCELLATION_SUBMIT_MISSING_BUYER_CHECK',
    'errors.workflow.confirmBuyerTerms'
  ),
  '59006': new RevxErrorCode(
    59006,
    'PROJECT_COMPLETE_JOB_FAILED',
    'errors.projects.completeJobFailed'
  ),
  '61001': new RevxErrorCode(
    61001,
    'BALANCE_REQUEST_FAILED',
    'errors.default.failure'
  ),
  '61003': new RevxErrorCode(61003, 'ORDER_EMPTY', 'errors.default.failure'),
  '61005': new RevxErrorCode(
    61005,
    'ORG_PAYMENT_CONFIG_INVALID',
    'errors.billing.orgPaymentConfigInvalid'
  ),
  '61006': new RevxErrorCode(61006, 'ORDER_PAID', 'errors.order.orderPaid'),
  '61007': new RevxErrorCode(
    61007,
    'PAYMENT_METHOD_UNSUPPORTED',
    'errors.default.failure'
  ),
  '61008': new RevxErrorCode(
    61008,
    'STRIPE_PAYMENT_FAILED',
    'errors.default.failure'
  ),
  '61009': new RevxErrorCode(
    61009,
    'BALANCE_VENDOR_CREATE_FAILED',
    'errors.default.failure'
  ),
  '61010': new RevxErrorCode(
    61010,
    'BALANCE_BUYER_ID_NOT_CONFIGURED_YET',
    'errors.platform.balanceBuyerIdNotConfiguredYet'
  ),
  '61011': new RevxErrorCode(
    61011,
    'BALANCE_VENDOR_CREATE_FAILED',
    'errors.platform.balanceBuyerIdInvalid'
  ),
  '61012': new RevxErrorCode(
    61012,
    'BALANCE_VENDOR_CREATE_FAILED',
    'errors.billing.balanceVendorIdInvalid'
  ),
  '61013': new RevxErrorCode(
    61013,
    'BALANCE_VENDOR_CREATE_FAILED',
    'errors.platform.balanceVendorIdInvalid'
  ),
  '61015': new RevxErrorCode(
    61015,
    'BALANCE_VENDOR_CREATE_FAILED',
    'errors.billing.invoiceFileInvalid'
  ),
  '61017': new RevxErrorCode(
    61017,
    'BALANCE_VENDOR_CREATE_FAILED',
    'errors.billing.balanceInvoiceNumberInvalid'
  ),
  '63001': new RevxErrorCode(
    63001,
    'UPS_RATE_PACKAGE_CODE_UNDEFINED',
    'errors.default.failure'
  ),
  '63002': new RevxErrorCode(
    63002,
    'FREIGHT_QUOTE_REQUEST_FAILED',
    'errors.default.failure'
  ),
  '63003': new RevxErrorCode(
    63003,
    'TRACKING_NUMBER_INVALID',
    'errors.default.failure'
  ),
  '63004': new RevxErrorCode(
    63004,
    'UPS_ADDRESS_VALIDATION_FAILED',
    'errors.shipping.upsAddressValidationFailed'
  ),
  '63005': new RevxErrorCode(
    63005,
    'UPS_REQUEST_FAILED',
    'errors.shipping.upsRequestFailed'
  ),
  '63006': new RevxErrorCode(
    63006,
    'UPS_TRACK_DETAIL_EXPIRED',
    'errors.shipping.upsTrackDetailExpired'
  ),
  '63007': new RevxErrorCode(
    63007,
    'UPS_TRACK_FALIED',
    'errors.shipping.upsTrackFalied'
  ),
  '64001': new RevxErrorCode(
    64001,
    'PDF_GENERATION_FAILED',
    'errors.default.failure'
  ),
  '65001': new RevxErrorCode(
    65001,
    'FILE_KEYS_EMPTY',
    'errors.default.failure'
  ),
  '65002': new RevxErrorCode(
    65002,
    'FILE_UPLOAD_FAILED',
    'errors.workflow.fileUploadFailed'
  ),
  '70001': new RevxErrorCode(
    70001,
    'CONTACT_GET_FAILED',
    'errors.default.failure'
  ),
  '70002': new RevxErrorCode(
    70002,
    'CONTACT_ADDR_GET_FAILED',
    'errors.default.failure'
  ),
  '70003': new RevxErrorCode(
    70003,
    'CONTACT_UPDATE_FAILED',
    'errors.default.failure'
  ),
  '70004': new RevxErrorCode(
    70004,
    'USER_CONTACT_GET_FAILED',
    'errors.default.failure'
  ),
  '70005': new RevxErrorCode(
    70005,
    'SUPPLIER_CONTACT_GET_FAILED',
    'errors.default.failure'
  ),
  '70006': new RevxErrorCode(
    70006,
    'USER_GET_FAILED',
    'errors.default.failure'
  ),
  '70007': new RevxErrorCode(70007, 'ORG_GET_FAILED', 'errors.default.failure'),
  '70008': new RevxErrorCode(
    70008,
    'ORG_NETWORK_GET_FAILED',
    'errors.default.failure'
  ),
  '70009': new RevxErrorCode(
    70009,
    'PRESS_GET_FAILED',
    'errors.default.failure'
  ),
  '70010': new RevxErrorCode(
    70010,
    'PRESS_TYPE_GET_FAILED',
    'errors.default.failure'
  ),
  '70011': new RevxErrorCode(
    70011,
    'INVOICE_SEND_FAILED',
    'errors.billing.invoiceIdInvalid'
  ),
  '70012': new RevxErrorCode(
    70012,
    'PAYMENT_CREATE_FAILED',
    'errors.default.failure'
  ),
  '70013': new RevxErrorCode(
    70013,
    'TAX_CALC_FAILED',
    'errors.shipping.taxCalcFailed'
  ),
  '70014': new RevxErrorCode(
    70014,
    'TAX_COMMIT_FAILED',
    'errors.default.failure'
  ),
  '70015': new RevxErrorCode(
    70015,
    'ORDER_GET_FAILED',
    'errors.default.failure'
  ),
  '70016': new RevxErrorCode(70016, 'JOB_GET_FAILED', 'errors.default.failure'),
  '71001': new RevxErrorCode(
    71001,
    'CALC_REQUEST_FAILED',
    'errors.default.failure'
  ),
  '71002': new RevxErrorCode(
    71002,
    'JOB_SPEC_SWITCH_ORG_FAILED',
    'errors.default.failure'
  ),
  '71003': new RevxErrorCode(
    71003,
    'JOB_SPEC_REORDER_FAILED',
    'errors.default.failure'
  ),
  '71004': new RevxErrorCode(
    71004,
    'JOB_SPEC_GET_AVL_PRESSES_FAILED',
    'errors.default.failure'
  ),
  '71005': new RevxErrorCode(
    71005,
    'JOB_CONFIG_START_FAILED',
    'errors.default.failure'
  ),
  '71006': new RevxErrorCode(
    71006,
    'JOB_CONFIG_UPDATE_FAILED',
    'errors.default.failure'
  ),
  '71007': new RevxErrorCode(
    71007,
    'QTY_ITEM_ADD_FAILED',
    'errors.default.failure'
  ),
  '71008': new RevxErrorCode(
    71008,
    'QTY_ITEM_UPDATE_FAILED',
    'errors.default.failure'
  ),
  '71009': new RevxErrorCode(
    71009,
    'JOB_SPEC_GET_AVL_ORGS_FAILED',
    'errors.default.failure'
  ),
  '71010': new RevxErrorCode(
    71010,
    'JOB_SPEC_GET_AVL_PAPERS_FAILED',
    'errors.default.failure'
  ),
  '71011': new RevxErrorCode(
    71011,
    'JOB_SPEC_SET_PARCEL_FAILED',
    'errors.default.failure'
  ),
  '71012': new RevxErrorCode(
    71012,
    'JOB_SPEC_GET_COST_DETAIL_FAILED',
    'errors.default.failure'
  ),
  '71013': new RevxErrorCode(
    71013,
    'JOB_SPEC_UPDATE_PRESSES_FAILED',
    'errors.default.failure'
  ),
  '71014': new RevxErrorCode(
    71014,
    'TURNTIME_GET_FAILED',
    'errors.default.failure'
  ),
  '71016': new RevxErrorCode(
    71016,
    'SOURCER_CONTACT_GET_FAILED',
    'errors.default.failure'
  ),
  '71017': new RevxErrorCode(
    71017,
    'SHIPPING_CONFIG_GET_FAILED',
    'errors.default.failure'
  ),
  '71018': new RevxErrorCode(
    71018,
    'MARKUP_CALC_FAILED',
    'errors.default.failure'
  ),
  '71019': new RevxErrorCode(
    71019,
    'SHIPPING_RATE_PACKAGE_FAILED',
    'errors.shipping.ratePackageFailed'
  ),
  '71020': new RevxErrorCode(
    71020,
    'SHIPPING_RATE_FREIGHT_FAILED',
    'errors.default.failure'
  ),
  '71021': new RevxErrorCode(
    71021,
    'SHIPPING_TRACK_FAILED',
    'errors.default.failure'
  ),
  '90001': new RevxErrorCode(90001, 'INTERNAL_ERROR', 'errors.default.failure'),
  '90002': new RevxErrorCode(90002, 'BAD_REQUEST', 'errors.default.failure'),
  '90003': new RevxErrorCode(
    90003,
    'STALE_ENTITY',
    'errors.general.staleEntity'
  ),
  '90004': new RevxErrorCode(
    90004,
    'GENERAL_INVALID_ARGS',
    'errors.default.failure'
  ),
  '90005': new RevxErrorCode(
    90005,
    'GENERAL_NOT_FOUND',
    'errors.default.failure'
  ),
  '90006': new RevxErrorCode(
    90006,
    'OPERATION_NOT_ALLOWED_ROLE_MISMATCH',
    'errors.default.failure'
  ),
  '90007': new RevxErrorCode(
    90007,
    'OPERATION_NOT_ALLOWED_ORG_MISMATCH',
    'errors.default.failure'
  ),
  '90008': new RevxErrorCode(
    90008,
    'NOT_IMPLEMENTED',
    'errors.default.failure'
  ),
  '90009': new RevxErrorCode(
    90009,
    'REDIS_LOCK_FAILED',
    'errors.default.failure'
  ),
};
// @formatter:on

export const lookupErrorCode = (code: number) => {
  const codeAsKey = code.toString();
  if (RevxErrorCodes[codeAsKey] === undefined) {
    return RevxErrorCodes['-1'];
  } else {
    return RevxErrorCodes[codeAsKey];
  }
};
